import React from 'react';

import { Box } from '../../Box';
import { Text } from '../../Typography';
import { titleStyles } from '../PackageCard.styles';
import type { PackageCardSize } from '../PackageCard.types';

type PackageCardContentHeaderProps = {
  size: PackageCardSize;
  startingPrice?: string;
  subtitle: React.ReactNode;
  title: string;
};

const PackageCardContentHeader = ({
  size,
  startingPrice,
  subtitle,
  title,
}: PackageCardContentHeaderProps) => (
  <Box
    display="flex"
    flexDirection="column"
    gap="var(--spacing-1)"
    mb="var(--spacing-2)"
  >
    <Box>
      <Text
        size={size === 'xs' ? 'sm' : 'md'}
        fontWeight="bold"
        css={titleStyles}
      >
        {title}
      </Text>
    </Box>

    <Box>
      <Text size={size === 'xs' ? 'xs' : 'sm'} fontWeight="bold">
        {subtitle}
      </Text>
    </Box>

    {startingPrice && (
      <Box>
        <Text size={size === 'xs' ? 'xs' : 'sm'} fontWeight="normal">
          Starting Price {startingPrice} / Guest
        </Text>
      </Box>
    )}
  </Box>
);

export default PackageCardContentHeader;
